baseApp.service('SlaSettingService', [ 'GeneralUtilsService', (GeneralUtilsService) =>{
    let serviceInstance = {};

    const DEFAULT_LAST_RESORT_ACTIVATE_AFTER_IN_SEC = 0;
    const DEFAULT_REOPTIMIZE_TIME_IN_SEC = 60 * 60; // 60 minutes
    serviceInstance.DEFAULT_PACKET_LOSS_IN_PERCENT = 10;
    serviceInstance.DEFAULT_AVERAGE_LATENCY_IN_MILLISECONDS = 300;
    serviceInstance.DEFAULT_EVALUATION_PERIOD_IN_SEC = 120;
    serviceInstance.INITIAL_CUSTOM_EVALUATION_PERIOD_IN_SEC = 130;
    serviceInstance.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC = 3;
    serviceInstance.DEFAULT_REOPTIMIZE_TIME_IN_MIN = 60;
    serviceInstance.SMART_SETTINGS = "SMART_SETTINGS";
    serviceInstance.CUSTOM_SETTINGS = "CUSTOM_SETTINGS";

    serviceInstance.siteHasLastResortLinks = (accountId, siteId, callback) => {
        store.fetch({
            method: "GET",
            path: "/siteHasLastResortLinks",
            queryParams: {accountId: accountId, siteId: siteId},
            success: (response) => {
                response ? callback(response) : callback(false);
            }
        });
    }

    serviceInstance.buildNewModel = () => {
        let newInstance = {
            id: GeneralUtilsService.getRandomId(),
            isNew: true,
            name: 'SlaSetting',
            type: "SLASETTING",
            evaluationPeriod: serviceInstance.DEFAULT_EVALUATION_PERIOD_IN_SEC,
            packetLoss: serviceInstance.DEFAULT_PACKET_LOSS_IN_PERCENT,
            averageLatency: serviceInstance.DEFAULT_AVERAGE_LATENCY_IN_MILLISECONDS,
            lastResortActivateAfter: DEFAULT_LAST_RESORT_ACTIVATE_AFTER_IN_SEC,
            primaryKeepAliveInterval: serviceInstance.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC,
            secondaryKeepAliveInterval: serviceInstance.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC,
            lastResortKeepAliveInterval: serviceInstance.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC,
            reoptimizeTime: DEFAULT_REOPTIMIZE_TIME_IN_SEC,
            disableReoptimization: false,
            overrideAccountGeneralSettings: false,
            overrideAccountKeepAliveSettings: false,
            overrideAccountReoptimizeTime: false,
            overrideAccountLastResortSettings: false,
        };
        return newInstance;
    };

    serviceInstance.reconnectToPreferredPop = (accountId, siteProtoId, callback) => {
        store.action({
            method: 'POST',
            url: 'reconnectToPreferredPop',
            queryParams: {
                accountId: accountId,
                siteProtoId: siteProtoId,
            },
            success: (response) => {
                response ? callback(response) : callback(false);
            }
        });
    }

    return serviceInstance;
}]);
